import createAuthAxios from 'common/lib/createAuthAxios';

const deleteSchedulingHold = async ({ holdId, url }: { holdId: number; url: string }) => {
  const authAxios = createAuthAxios();
  await authAxios.delete(url, { data: { coaching_scheduling_hold_id: holdId } });
};

export default deleteSchedulingHold;
